import React, { useEffect } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { useAuth } from '@leagueplatform/auth-utils';
import { Spinner } from '@leagueplatform/genesis-core';
import { LOCAL_STORAGE_TENANT_ID_KEY } from 'constants/locale-storage';
import { StandaloneAuth } from '@leagueplatform/auth-standalone';
import { ErrorState } from '@leagueplatform/web-common-components';
import { FullScreenContainer } from 'components/full-screen-container/full-screen-container.component';
import { captureAuthenticationError } from './capture-auth-error.component';

export const CSAuthSessionContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { isAuthenticated, error: authError } = useAuth({
    redirectToLogInWhenSignedOut: false,
  });

  const [tenantId] = useLocalStorage(LOCAL_STORAGE_TENANT_ID_KEY, '');

  useEffect(() => {
    if (authError) {
      captureAuthenticationError(authError);
    }
  }, [authError]);

  if (isAuthenticated === undefined) {
    return <Spinner loading />;
  }

  if (authError) {
    return (
      <FullScreenContainer backgroundColor="surface.background.primary">
        <ErrorState
          error={authError}
          headingString={authError.type}
          bodyString={authError.description || ''}
          hideButton
        />
      </FullScreenContainer>
    );
  }

  if (!isAuthenticated && tenantId) {
    StandaloneAuth.client.loginWithRedirect();
    return null;
  }

  if (!isAuthenticated) {
    return (
      <FullScreenContainer backgroundColor="surface.background.primary">
        <ErrorState
          error={null}
          headingString="Not Authenticated."
          bodyString="You are currently not logged in with an active session."
          hideButton
        />
      </FullScreenContainer>
    );
  }

  return <div>{children}</div>;
};
